import { createSvg } from '@r1-frontend/ui-kit/atoms/svg/сreateSvg';

const Close = (
    {
        strokeWidth = 1.5,
    },
): JSX.Element => {
    return (
        <g id={'guts'}>
            <path
                d='M7 17L17 7'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M17 17L7 7'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
    );
};

export default createSvg(
    Close,
    'close',
);
